<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted font-13 mb-4"></p>
                        <div class="row mb-md-2">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions">
                                        </b-form-select>&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ml-2">
                                        </b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    ref="requestHistoryTable"
                                    :items="requestsData"
                                    :busy.sync="isBusy"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn">

                                <template v-slot:cell(id)="row">
                                    <a href="javascript: void(0);"
                                       class="text-body font-weight-bold"
                                    >{{row.item.id}}</a>
                                </template>


                                <template v-slot:cell(action)="row">
                                    <b-button :id="row.item.id" variant="primary"
                                              type="button" class="btn btn-blue" @click="showModal(row.item)">
                                        <i class="mdi mdi-eye"></i>
                                    </b-button>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="rows"
                                                :per-page="perPage"
                                                @input =" pageChange(currentPage);">
                                        </b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="remark-modal" ref="remark" size="lg" title="Description" title-class="font-18">
            <p>{{ selectedRow }}</p>
            <div class="form-group">
                <div class="button-list">
                    <button type="button"
                            class="btn btn-success"
                            @click="approve">
                            <span class="btn-label"><i class="mdi mdi-thumb-up-outline"></i>
                            </span>Approve
                    </button>

                    <button type="button"
                            class="btn btn-danger"
                            @click="reject">
                        <span class="btn-label"><i class="mdi mdi-thumb-down-outline"></i>
                        </span>Reject
                    </button>
                </div>
            </div>
        </b-modal>
    </Layout>
</template>

<script>
  import appConfig from '@src/app.config'
  import Layout from '@layouts/main'
  import PageHeader from '@components/page-header'

  import { fundRequestMethods } from '@state/helpers'


  /**
   * Advanced table component
   */
  export default {
    page: {
      title: 'Fund Requests',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
      return {
        fundRequests: [],
        status: '',
        title: 'Fund Requests',
        items: [
          {
            text: '99Gift',
            href: '/',
          },
          {
            text: 'Fund Requests',
            href: '/',
          },
          {
            text: this.capitalize(`${this.$route.params.status} funds requests`),
            active: true,
          },
        ],
        isBusy: false,
        remarkDetail: null,
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: 'id',
        sortDesc: false,
        selectedRow: null,
        fields: [
          { key: 'id', label: 'Id', sortable: true },
          { key: 'company.name', label: 'Company name', sortable: false },
          { key: 'amount', label: 'Amount', sortable: true },
          { key: 'bank.title', label: 'Bank', sortable: true },
          { key: 'payment.title', label: 'Mode.', sortable: true },
          { key: 'created_at', label: 'Request date', sortable: false },
          { key: 'amount',  label: 'Amount', sortable: false },
          { key: 'action',  label: 'Action', sortable: false },
        ],
      }
    },
    computed: {
      /**
       * Total no. of records
       */
      rows() {
        return this.totalRows
      },
    },
    mounted() {

      this.status = this.$route.params.status
      this.title = this.capitalize(`${this.status} funds requests`)
    },
    methods: {
      ...fundRequestMethods,

      /**
       * Search the table data with search input
       */
      async requestsData(context) {

        const { sortBy, sortDesc , perPage, currentPage } = context;

        this.currentPage = currentPage;
        this.rowsPerPage = perPage;

        this.isBusy = true

        try{
          const { success, message, data: { result } } = await this.requestHistory({
            page: this.currentPage,
            rowsPerPage: this.perPage,
            sortBy,
            descending: sortDesc,
            value: this.status
          });

          if(!success) throw Error(message)

          this.totalRows = result.totalCount
          this.fundRequests =  result.data
        }
        catch (e){

          this.fundRequests = []
          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }

        this.isBusy = false
        return this.fundRequests;
      },

      async pageChange(page){

        this.currentPage = page
      },

      showModal(data){
        this.selectedRow = data
        if(data.order_id){
          this.remarkDetail = 'Order status is '+data.order_status;
        }
        else{
          this.remarkDetail = 'No remarks found!'
        }
        this.$refs.remark.show()
      },

      approve(){
        this.fundAction(this.selectedRow.id, true)
      },

      reject(){
        this.fundAction(this.selectedRow.id, false)
      },

      async fundAction(id, action){


        try{
          const { success, message} = await this.actionFund({
            id, action
          });

          if(!success) throw Error(message)

          if(action){
            this.appToast('Success',  message, 'success')
          }
          else {
            this.appToast('Success',  message, 'success')
          }

        }
        catch (e){

          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }
      },

    },
  }
</script>